Modernizr.on('webp', function (result) {
  if (result) {
    // supported
  } else {
    // not-supported
  }
});

// IE polyfill
objectFitVideos();

// passive listener
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    this.addEventListener("touchstart", handle, { passive: true });
  }
};

// rolling start!
$(function(){
  if ('ontouchstart' in window || 'ontouch' in window) {
    $('body').addClass('touch');
  }

  // hamburger action
  $('.hamburger').click(function(){
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-active');
  });

  // accordion
  $('.faq-item').accordion({
    "transitionSpeed": 400
  });

  $('.modal-video').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  $('.trailer-video').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,

    callbacks: {
      open: function() {
        // Will fire when this exact popup is opened
        // this - is Magnific Popup object
        var vid = $('.video-hero').find('video');
        if (vid.length > 0) {
          $(vid)[0].pause();
        }
      },
      close: function() {
        // Will fire when popup is closed
        var vid = $('.video-hero').find('video');
        if (vid.length > 0) {
          $(vid)[0].play();
        }
      }
    }
  });

  // hilight side nav on click
  $('.side-nav__list a').click( function() {
    $('.side-nav__list a').parent().removeClass('selected');
    $(this).parent().addClass('selected');
  });
  
  // toggle aria modal for games buying
  $('#buying-options, .modal-close').click(function(){
    $('body').toggleClass('modal-open');
    $('.modal').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });

    $('.modal').click(function() {
      $('body').removeClass('modal-open');
      $('.modal').attr('aria-expanded', 'false');
    });

    $(document).on('keydown',function(event) {
      if (event.keyCode == 27) {
        $('body').removeClass('modal-open');
        $('.modal').attr('aria-expanded', 'false');
      }
    });
  });

  // Smooth scroll internal hash links
  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});